import { Info, Mail, Code, FileText, AppWindow } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function AboutPage() {
  const { t } = useTranslation('about')
  const appVersion = import.meta.env.VITE_APP_VERSION || 'dev'
  const apiVersion = 'v1.0 (static)'

  return (
    <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1rem' }}>
      {/* Hero Section */}
      <section style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '80px', height: '80px', borderRadius: '50%', background: 'var(--bg-card)', border: '1px solid var(--border)', marginBottom: '1rem' }}>
          <div className="logo-mark" style={{ fontSize: '2rem' }}>H</div>
        </div>
        <h1 className="h1" style={{ marginBottom: '0.5rem' }}>HeliumTracker</h1>
        <p className="text-large muted">{t('hero.tagline')}</p>
      </section>

      <div style={{ display: 'grid', gap: '2rem' }}>
        {/* Was ist HeliumTracker */}
        <section className="card">
          <div className="card-header">
            <h2 className="h3" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Info size={20} className="ic" />
              {t('whatIs.title')}
            </h2>
          </div>
          <div className="card-body">
            <p>
              {t('whatIs.body')}
            </p>
          </div>
        </section>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          {/* Versionen */}
          <section className="card">
            <div className="card-header">
              <h2 className="h3" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <AppWindow size={20} className="ic" />
                {t('versions.title')}
              </h2>
            </div>
            <div className="card-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div>
                  <div className="text-small muted">{t('versions.appVersion')}</div>
                  <div style={{ fontFamily: 'monospace', fontSize: '1.1em' }}>{appVersion}</div>
                </div>
                <div>
                  <div className="text-small muted">{t('versions.apiVersion')}</div>
                  <div style={{ fontFamily: 'monospace', fontSize: '1.1em' }}>{apiVersion}</div>
                </div>
              </div>
            </div>
          </section>

          {/* Team / Kontakt */}
          <section className="card">
            <div className="card-header">
              <h2 className="h3" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Mail size={20} className="ic" />
                {t('contact.title')}
              </h2>
            </div>
            <div className="card-body">
              <p style={{ marginBottom: '1rem' }}>
                {t('contact.intro')}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <a href="mailto:support@heliumtracker.io" className="btn btn-outline" style={{ justifyContent: 'flex-start' }}>
                  <Mail size={16} />
                  support@heliumtracker.io
                </a>
              </div>
            </div>
          </section>
        </div>

        {/* Open-Source */}
        <section className="card">
          <div className="card-header">
            <h2 className="h3" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Code size={20} className="ic" />
              {t('openSource.title')}
            </h2>
          </div>
          <div className="card-body">
            <p className="muted" style={{ marginBottom: '1rem' }}>
              {t('openSource.intro')}
            </p>
            <ul style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.5rem', listStyle: 'none', padding: 0 }}>
              <li>• React 19</li>
              <li>• TanStack Router</li>
              <li>• TanStack Query</li>
              <li>• Zustand</li>
              <li>• Recharts</li>
              <li>• MapLibre GL JS</li>
              <li>• Solana Wallet Adapter</li>
              <li>• openapi-fetch</li>
              <li>• Vite</li>
              <li>• Vitest</li>
              <li>• Lucide React</li>
            </ul>
          </div>
        </section>

        {/* Lizenz */}
        <section className="card">
          <div className="card-header">
            <h2 className="h3" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FileText size={20} className="ic" />
              {t('license.title')}
            </h2>
          </div>
          <div className="card-body">
            <p>
              {t('license.body')}
              <br/><br/>
              <span className="muted text-small">{t('license.copyright', { year: new Date().getFullYear() })}</span>
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}
